import { createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers'


const composeEnhanders = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer,
    composeEnhanders(
        applyMiddleware(thunk)
    )
);

export default store;


// WEBPACK FOOTER //
// ./src/store.js